import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';
import { getContext } from '@fiverr-private/fiverr_context';
import { trackBiEvent as trackAgencyBiEvent } from '../../../services/agencyTracker';
import { trackBiEvent } from '../../../services/tracker';
import { BI_CONSTS } from '../../../constants';
import { TYPES } from '../../../utils';
import { trackHover, trackClick } from '../../../services/report';
import { ConfigMenuItemProps } from '../../../types';
import ItemIcon from '../../ItemIcon';
import Badge from '../../Badge';

import './index.scss';

// eslint-disable-next-line react/prop-types
const RenderedItem = ({ isStatic, children, onMouseOver, ...rest }) => isStatic ? <p onMouseOver={onMouseOver}>{children}</p> : <a onMouseOver={onMouseOver} {...rest}>{children}</a>;

RenderedItem.propTypes = {
    isStatic: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.elementType,
        PropTypes.arrayOf(
            PropTypes.oneOfType([
                PropTypes.elementType,
                PropTypes.object
            ])
        )
    ]),
    rest: PropTypes.object
};

const MenuItem = ({ item, handleClick, handleMouseLeave, handleMouseOver, children, className, eventTracker = {}, preventCloseAction, level, showAgenciesBanner }) => {
    const { organizationId } = getContext();
    const { url, displayName, badge, type, style } = item;

    const isStatic = type === TYPES.STATIC;
    const trackingData = {
        vertical: eventTracker.vertical,
        context: eventTracker.context,
        bucket: eventTracker.bucket,
        entry: eventTracker.entry,
        path: url,
        organizationId
    };

    const onClickStaticItem = () => {
        trackClick(trackingData);
        trackBiEvent('click_on_navigation_bar_option', { item, actionType: BI_CONSTS.CLICK, trackingData, elementType: BI_CONSTS.LINK });
    };

    const onClick = () => {
        trackClick(trackingData);
        trackBiEvent('click_on_navigation_bar_option', { item, actionType: BI_CONSTS.CLICK, trackingData, elementType: BI_CONSTS.LINK });

        if (_.isFunction(handleClick)) {
            handleClick();
        }
    };

    const onMouseOver = (e) => {
        if (_.isFunction(handleMouseOver)) {
            handleMouseOver(e);
            trackHover(trackingData);

            if (typeof showAgenciesBanner === 'boolean') {
                trackAgencyBiEvent('hover_on_navigation_bar_header', { item, actionType: BI_CONSTS.HOVER, trackingData, elementType: BI_CONSTS.HOVER, agencyBannerExists: showAgenciesBanner });
            } else {
                trackBiEvent('hover_on_navigation_bar_header', { item, actionType: BI_CONSTS.HOVER, trackingData, elementType: BI_CONSTS.HOVER });
            }
        }
    };

    const onMouseLeave = (e) => {
        if (_.isFunction(handleMouseLeave)) {
            handleMouseLeave(e);
        }
    };

    const menuItemClasses = classnames('sub-menu-item', { [className]: !!className, static: isStatic, [style]: !!style });

    return (
        <li ref={preventCloseAction}
            data-level={level}
            className={menuItemClasses}
            onMouseLeave={onMouseLeave}>
            <RenderedItem onMouseOver={onMouseOver} isStatic={isStatic} href={url} onClick={onClick} onClickStaticItem={onClickStaticItem}>
                {displayName}
                <Badge type={badge}/>
                <ItemIcon style={style}/>
            </RenderedItem>
            {children}
        </li>
    );
};

MenuItem.propTypes = {
    handleClick: PropTypes.func,
    preventCloseAction: PropTypes.func,
    handleMouseLeave: PropTypes.func,
    handleMouseOver: PropTypes.func,
    item: ConfigMenuItemProps,
    children: PropTypes.element,
    className: PropTypes.string,
    eventTracker: PropTypes.object,
    level: PropTypes.string,
    showAgenciesBanner: PropTypes.bool
};

export default MenuItem;
